import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SeoService {

  private link: HTMLLinkElement;

  constructor(@Inject(DOCUMENT) private doc,
    private title: Title,
    private meta: Meta,
  ) { }

  createLinkForCanonicalURL(url: string) {


  }


  updateMetaTags(
    title: string,
    description: string,
    //url: string,
    image: string,
    canonicalUrl: string
  ) {
    /* Primary Meta Tags */
    this.title.setTitle(title);
    this.meta.updateTag({ property: "title", content: title });
    this.meta.updateTag({ property: "description", content: description });

    /* Open Graph / Facebook */
    this.meta.updateTag({ property: "og:type", content: "website" });
    // this.meta.updateTag({ property: "og:url", content: url });
    this.meta.updateTag({ property: "og:title", content: title });
    this.meta.updateTag({ property: "og:description", content: description });
    this.meta.updateTag({ property: "og:image", content: image });

    if (this.link === undefined) {
      this.link = this.doc.createElement('link');
      this.link.setAttribute('rel', 'canonical');
      this.doc.head.appendChild(this.link);
    }
    this.link.setAttribute('href', canonicalUrl);

  }

  extractContent150(s) {
    var span = document.createElement('span');
    span.innerHTML = s;
    return (span.textContent || span.innerText).substring(0, 150);
  };
} 